import pageContext from 'salvo-lite/context'
import Slider from './components/Slider'
import Instagram from './components/Instagram'
import Accordion from './components/Accordion'
import ChoicesSelect from './components/ChoicesSelect'
import LoadMore from './components/LoadMore'
import Product from './components/Product'
import ReadMore from './components/ReadMore'
import Search from './components/Search'
import SelectURL from './components/SelectURL'
import SortElements from './components/SortElements'
import StickyElem from './components/StickyElem'
import ToggleClasses from './components/ToggleClasses'
import VideoContainer from './components/VideoContainer'
import Cart from './components/Cart'
import Header from './components/Header'
import QuickView from './components/QuickView'
import Reveal from './components/Reveal'
import Parallax from './components/Parallax'
import SlidingMenu from './components/SlidingMenu'
import SortURL from './components/SortURL'
import YoutubeVideo from './components/YoutubeVideo'
import FullPage from './components/FullPage'
import NewsletterPopup from './components/NewsletterPopup'
import ToggleSearch from './components/ToggleSearch'
import HoverPoints from './components/HoverPoints'
import Footer from './components/Footer'
import PlusMinusInput from './components/PlusMinusInput'
import RemoveWhenOutside from './components/RemoveWhenOutside'
import AjaxCart from './components/AjaxCart'
import StoreLocator from './components/StoreLocator'
import RecentlyViewed from './components/RecentlyViewed'
import Navigation from './components/Navigation'
import SetChoicesValue from './components/SetChoicesValue'
import CookieBanner from './components/CookieBanner'
import Photoswipe from './components/Photoswipe'
import ScrollBar from './components/ScrollBar'
import CountryProvinceSelector from './components/CountryProvinceSelector'
import ProductPdf from './components/ProductPDF'
import ProductGridItem from './components/Product-grid-item'
import DeliveryEstimator from './components/DeliveryEstimator'
import CartRedirect from './components/CartRedirect'
import OpenChat from './components/OpenChat'
import WishlistBack from './components/WishlistBack'
import ForceLinksToNewTab from './components/ForceLinksToNewTab'
import Caption from './components/Caption'
import ProductPage from './pages/Product'

const components = {
    'photoswipe': Photoswipe,
    'slider': Slider,
    'instagram': Instagram,
    'accordion': Accordion,
    'choices-select': ChoicesSelect,
    'load-more': LoadMore,
    'product': Product,
    'read-more': ReadMore,
    'search': Search,
    'select-url': SelectURL,
    'sort-group': SortElements,
    'sticky': StickyElem,
    'toggle-class': ToggleClasses,
    'add-class': ToggleClasses,
    'remove-class': ToggleClasses,
    'video-container': VideoContainer,
    'cart': Cart,
    'header': Header,
    'quick-view': QuickView,
    'scroll-reveal': Reveal,
    'parallax': Parallax,
    'sliding-menu': SlidingMenu,
    'sort-url': SortURL,
    'youtube-video': YoutubeVideo,
    'full-page': FullPage,
    'newsletter-popup': NewsletterPopup,
    'toggle-search': ToggleSearch,
    'footer': Footer,
    'hover-points': HoverPoints,
    'plus-minus-input': PlusMinusInput,
    'remove-when-outside': RemoveWhenOutside,
    'ajax-cart': AjaxCart,
    'store-locator': StoreLocator,
    'scrollbar': ScrollBar,
    'recently-viewed': RecentlyViewed,
    'navigation': Navigation,
    'set-choices-value': SetChoicesValue,
    'cookie-banner': CookieBanner,
    'country-province-selector': CountryProvinceSelector,
    'product-pdf': ProductPdf,
    'product-grid-item': ProductGridItem,
    'delivery-estimator': DeliveryEstimator,
    'cart-redirect': CartRedirect,
    'open-chat': OpenChat,
    'wishlist-back': WishlistBack,
    'caption': Caption,
    'force-links-to-new-tab': ForceLinksToNewTab
}

const pages = {
    'product': ProductPage
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}

        if (document.querySelector('[data-theme-locale]')) {
            this.locale = JSON.parse(document.querySelector('[data-theme-locale]').innerHTML)
        } else {
            this.locale = {}
        }

        if (document.querySelector('[data-shop-info]')) {
            this.shopInfo = JSON.parse(document.querySelector('[data-shop-info]').innerHTML)
        } else {
            this.shopInfo = {
                currency: 'GBP'
            }
        }
    }

    registerComponents (regsiterContainer = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = regsiterContainer.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js